import useTraces from "@/hooks/useTraces";
import useUsers from "@/hooks/useUsers";
import useWebSocket from "@/hooks/useWebSocket";
import useGlobalStore from "@/services/store/useGlobalStore";
import { logger } from "@/utils/functions/logger";
import { useEffect } from "react";

interface IWebSocketProviders {
  children: React.ReactNode;
}

const WebSocketProviders: React.FC<IWebSocketProviders> = ({ children }) => {
  const { updateState } = useGlobalStore((state) => state);
  const { getUsers, updateUserFromWS } = useUsers();
  const { updateTraceFromWs } = useTraces();

  const { message } = useWebSocket(`${process.env.REACT_APP_WS_HOST}:${process.env.REACT_APP_WS_PORT}/ws`, [
    "USER_CONNECTED",
    "USER_DISCONNECTED",
    "USER_STATE",
    "USER_UPDATED",
    "TRACE_UPDATED",
  ]);

  const updateTrace = (message: WebSocketMessage) => {
    try {
      const newTrace = JSON.parse(message.content) as TraceUpdatedWS;
      updateTraceFromWs(newTrace);
    } catch (e) {
      logger.error(e);
    }
  };

  const updateUserState = (message: WebSocketMessage) => {
    try {
      const newState = JSON.parse(message.content) as UserState;
      updateState(newState.alias, newState);
    } catch (e) {
      logger.error(e);
    }
  };

  const updateUser = (message: WebSocketMessage) => {
    try {
      const newUser = JSON.parse(message.content) as WSUser;
      updateUserFromWS(newUser);
    } catch (e) {
      logger.error(e);
    }
  };

  useEffect(() => {
    if (!message) return;

    if (message.type === "TRACE_UPDATED") {
      updateTrace(message);
    } else if (message.type === "USER_UPDATED") {
      updateUser(message);
    } else {
      if (message.type === "USER_STATE") {
        updateUserState(message);
      }
      getUsers(false);
    }
  }, [message]);

  return <>{children}</>;
};

export default WebSocketProviders;
